import userProfile from 'user-profile';

function DefaultPage(params) {
    this.loggedIn = userProfile.loggedIn;
    this.userProfileInitialized = userProfile.userProfileInitialized;
}

import template from './default-page.html';

export default  { viewModel: DefaultPage, template: template };